<template>
	<div class="wrapper">
		<side-bar v-if="$store.state.authentication.account_type == 'ad'">
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>របាយការណ៏</p>
			</sidebar-link>
			<sidebar-link to="/deposits">
				<md-icon>account_balance</md-icon>
				<p>ការដាក់ប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/withdraws">
				<md-icon>paid</md-icon>
				<p>ការដកប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/clients">
				<md-icon>groups</md-icon>
				<p>អតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/payments">
				<md-icon>receipt_long</md-icon>
				<p>ការទូទាត់ប្រាក់</p>
			</sidebar-link>
		</side-bar>

		<side-bar v-if="$store.state.authentication.account_type == 'sa'">
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>របាយការណ៏</p>
			</sidebar-link>
			<sidebar-link to="/deposits">
				<md-icon>account_balance</md-icon>
				<p>ការដាក់ប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/withdraws">
				<md-icon>paid</md-icon>
				<p>ការដកប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/clients">
				<md-icon>groups</md-icon>
				<p>អតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/referrals">
				<md-icon>diversity_3</md-icon>
				<p>អ្នកណែនាំ</p>
			</sidebar-link>
			<sidebar-link to="/payments">
				<md-icon>receipt_long</md-icon>
				<p>ការទូទាត់ប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/bet_reports">
				<md-icon>leaderboard</md-icon>
				<p>របាយការណ៏អតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/reports">
				<md-icon>analytics</md-icon>
				<p>របាយការណ៏អ្នកផ្គត់ផ្គង់</p>
			</sidebar-link>
			<sidebar-link to="/settings">
				<md-icon>settings</md-icon>
				<p>ការកំណត់</p>
			</sidebar-link>
			<sidebar-link to="/administrators">
				<md-icon>supervised_user_circle</md-icon>
				<p>ការកំណត់គណនី</p>
			</sidebar-link>
		</side-bar>

		<side-bar v-if="$store.state.authentication.account_type == 'oa'">
			<sidebar-link to="/dashboard">
				<md-icon>dashboard</md-icon>
				<p>របាយការណ៏</p>
			</sidebar-link>
			<sidebar-link to="/deposits">
				<md-icon>account_balance</md-icon>
				<p>ការដាក់ប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/withdraws">
				<md-icon>paid</md-icon>
				<p>ការដកប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/clients">
				<md-icon>groups</md-icon>
				<p>អតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/referrals">
				<md-icon>diversity_3</md-icon>
				<p>អ្នកណែនាំ</p>
			</sidebar-link>
			<sidebar-link to="/payments">
				<md-icon>receipt_long</md-icon>
				<p>ការទូទាត់ប្រាក់</p>
			</sidebar-link>
			<sidebar-link to="/bet_reports">
				<md-icon>leaderboard</md-icon>
				<p>របាយការណ៏អតិថិជន</p>
			</sidebar-link>
			<sidebar-link to="/settings">
				<md-icon>settings</md-icon>
				<p>ការកំណត់</p>
			</sidebar-link>
		</side-bar>


		<div class="main-panel">
			<top-navbar></top-navbar>

			<dashboard-content>

			</dashboard-content>

			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
	</div>
</template>

<script>
	import TopNavbar from './TopNavbar.vue'
	import ContentFooter from './ContentFooter.vue'
	import DashboardContent from './Content.vue'

	export default {
		components: {
			TopNavbar,
			DashboardContent,
			ContentFooter
		}
	}
</script>



// WEBPACK FOOTER //
// src/pages/Layout/DashboardLayout.vue